/* eslint-disable max-len */
/* eslint-disable tailwindcss/no-arbitrary-value */
import React from 'react';
import { number } from 'prop-types';

export const ResultCount = ({ count }) => {
  const resultsText = count === 1 ? 'Result' : 'Results';
  return (<div className="sui-flex sui-flex-1 sui-font-bold sui-items-center sui-ml-0 lg:sui-ml-1 lg:sui-bg-primary sui-bg-subtle">{count}&nbsp;{resultsText}</div>);
};

ResultCount.propTypes = {
  count: number.isRequired
};
